"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClickableAreaStyled = exports.PlusStyled = exports.CirclePathStyled = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _hotspot = require("../../hotspot.constants");

var _hotspotGlobal = require("../../hotspot.global.styles");

var _svgElements = require("../../components/svg-elements");

var _hotspot2 = _interopRequireDefault(require("../../hotspot.styles"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

var CirclePathStyled = (0, _styledComponents.default)(_svgElements.Path).withConfig({
  displayName: "Plusstyles__CirclePathStyled",
  componentId: "sc-1xiqic7-0"
})(["opacity:0.25;transition:all 0.3s ease;"]);
exports.CirclePathStyled = CirclePathStyled;

var PlusStyled = _styledComponents.default.div.withConfig({
  displayName: "Plusstyles__PlusStyled",
  componentId: "sc-1xiqic7-1"
})(["position:absolute;left:", "%;top:", "%;height:4em;width:4em;opacity:", ";transform:", ";cursor:pointer;"], function (_ref) {
  var iconPosition = _ref.iconPosition;
  return iconPosition.left;
}, function (_ref2) {
  var iconPosition = _ref2.iconPosition;
  return iconPosition.top;
}, function (_ref3) {
  var config = _ref3.config;
  return config.opacity || 1;
}, _hotspotGlobal.translateXY);

exports.PlusStyled = PlusStyled;
var hoverState = "\n  ".concat(CirclePathStyled, " {\n    opacity: 1;\n  }\n");
var ClickableAreaStyled = (0, _styledComponents.default)(_hotspot2.default).withConfig({
  displayName: "Plusstyles__ClickableAreaStyled",
  componentId: "sc-1xiqic7-2"
})(["", ""], function (_ref4) {
  var disableHover = _ref4.disableHover;
  return !disableHover && (0, _styledComponents.css)(["&:hover,&", "{", ";}", ""], _hotspot.focusVisible, hoverState, function (_ref5) {
    var previewHoverState = _ref5.previewHoverState;
    return previewHoverState && hoverState;
  });
});
exports.ClickableAreaStyled = ClickableAreaStyled;